"use client";

import React from 'react';
import '@/app/tufte.css';
import '@/app/toc.css';
import '@/app/tufte-charts.css';
import { parseAndSplitByH2 } from '@/lib/parseMarkdown';
import Markdown, { FootnoteRef } from '@/app/Markdown';
import Provider from '@/translations/ja/Provider';
import SetHtmlLang from '@/app/components/SetHtmlLang';

import narrativeMarkdown from '@/translations/ja/markdown/narrative.md';
import raceMarkdown from '@/translations/ja/markdown/race.md';
import slowdownMarkdown from '@/translations/ja/markdown/slowdown.md';

function extractFootnotes(markdownContent: string) {
  const chunks = parseAndSplitByH2(markdownContent);
  // Assume all footnotes have been collected in the first chunk's docContext.
  return chunks.length > 0 && chunks[0].docContext ? chunks[0].docContext.footnotes : [];
}

export default function JapaneseFootnotesPage() {
  const narrativeFootnotes = extractFootnotes(narrativeMarkdown);
  const raceFootnotes = extractFootnotes(raceMarkdown);
  const slowdownFootnotes = extractFootnotes(slowdownMarkdown);

  const renderFootnoteList = (footnotes: any[], prefix: string = '') => {
    if (!footnotes || footnotes.length === 0) {
      return <p className="text-sm">脚注はありません。</p>;
    }
    const queryString = prefix ?? '';
    return (
      <div>
        {footnotes.map((footnote) => (<div key={footnote.identifier} className="flex gap-10 scroll-mt-5" id={`footnote-${prefix ? `${prefix}-${footnote.identifier}` : footnote.identifier}`}>
          <h2 className="w-12 align-self-start mt-0 mb-0 not-italic">[{footnote.identifier}]</h2>
          <div className="[&>*:first-child]:mt-0 mb-6">
            <Markdown nodes={footnote.children} FootnoteHandler={FootnoteRef} />
            <span>&nbsp;&nbsp;</span>
            <a href={`/ja/${queryString}#footnote-${prefix ? `${prefix}-${footnote.identifier}` : footnote.identifier}`} className="text-sm">↩</a>
          </div>
        </div>))}
      </div>
    );
  };

  return (
    <Provider>
      <SetHtmlLang lang="ja" />
      <main className="max-w-none [grid-area:topGraph/content/content/content] p-6 footnote-page">
        <h1 className="text-3xl font-bold mb-6">脚注</h1>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">本編</h2>
          {renderFootnoteList(narrativeFootnotes)}
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">競争する結末</h2>
          {renderFootnoteList(raceFootnotes, "race")}
        </section>
        <section>
          <h2 className="text-2xl font-semibold mb-4">減速する結末</h2>
          {renderFootnoteList(slowdownFootnotes, "slowdown")}
        </section>
      </main>
    </Provider>
  );
}
